function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { CardNumberElement } from '@stripe/react-stripe-js';
import { CreditCardSvgIcon } from 'swag-client-common/components/svg/credit-card.svg';
import { StripeElementsShortName } from 'swag-common/interfaces/stripe';
import { getCardNumberStyles } from 'swag-client-common/components/partials/stripe-elements-hoc/stripe-elements';
import responsiveClasses from './stripe-element-card-number.scss';
import fixedClasses from './stripe-element-card-number-fixed.scss';
export default class StripeCardNumberElement extends React.Component {
  render() {
    const {
      popupType,
      errorCardNumberString,
      isFixedStyles,
      onChangeStripeField
    } = this.props;
    const classes = isFixedStyles ? fixedClasses : responsiveClasses;
    const CARD_NUMBER_ELEMENT_OPTIONS = _objectSpread({}, getCardNumberStyles(popupType, isFixedStyles), {
      placeholder: 'Card Number'
    });
    return /*#__PURE__*/React.createElement("div", {
      className: classes.stripeInput
    }, errorCardNumberString && /*#__PURE__*/React.createElement("span", {
      className: classes.stripeCardNumberValidation
    }, errorCardNumberString), /*#__PURE__*/React.createElement("div", {
      className: classes.stripeInputIcons
    }, /*#__PURE__*/React.createElement(CreditCardSvgIcon, null)), /*#__PURE__*/React.createElement(CardNumberElement, {
      id: "cardNumber",
      onChange: onChangeStripeField(StripeElementsShortName.NUMBER),
      options: CARD_NUMBER_ELEMENT_OPTIONS
    }));
  }
}